<template>
  <div>
    <b-modal size="lg" hide-footer v-model="modalAmortizations" class="w-100" :title="CodeInvoice(account_receivable.type_invoice) +' '+ account_receivable.serie+'-'+ account_receivable.number + ' | Amortizaciones'">
      <b-form id="Form" autocomplete="off" @submit.prevent="Validate">
        <b-row>
          <b-col md="3">
            <b-form-group label="Medio de Pago :">
              <b-form-select v-model="amortization.payment_method" :options="payment_method"></b-form-select>
              <small v-if="errors.payment_method" class="form-text text-danger" >Seleccione un metodo</small>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Documento :">
              <b-form-input v-model="amortization.document"></b-form-input>
              <small v-if="errors.document" class="form-text text-danger" >Ingrese un documento</small>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Fecha de Cobro:">
              <b-form-input type="date" :max="amortization.date_now" ref="broadcast_date" v-model="amortization.broadcast_date" ></b-form-input>
              <small v-if="errors.broadcast_date" class="form-text text-danger">Seleccione una fecha</small>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Banco :">
              <b-form-select  v-model="amortization.bank" :options="bank"></b-form-select>
              <small v-if="errors.bank" class="form-text text-danger">Ingrese un banco</small>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Nro Operación :">
              <b-form-input type="text"  v-model="amortization.number_op"></b-form-input>
              <small v-if="errors.number_op"  class="form-text text-danger" >Ingrese una nro de operación</small>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Moneda:">
              <b-form-select disabled v-model="amortization.coin" :options="coins" ></b-form-select>
              <small v-if="errors.coin" class="form-text text-danger">Seleccione una moneda</small>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="T. Cambio:">
              <b-form-input type="number" class="text-right" step="any" v-model="amortization.exchange_rate" ></b-form-input>
              <small v-if="errors.exchange_rate" class="form-text text-danger">Seleccione un tipo de cambio</small>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Total:">
              <b-form-input type="number" class="text-right" step="any" v-model="amortization.total" ></b-form-input>
              <small v-if="errors.total" class="form-text text-danger">Ingrese un monto</small>
            </b-form-group>
          </b-col>


          <b-col md="7">
              <div class="table-responsive">
                <table class="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th width="30%" class="text-center">F. Emision</th>
                      <th width="30%" class="text-center">F. Vencimiento</th>
                      <th width="10%" class="text-center">Moneda</th>
                      <th width="15%" class="text-center">Total</th>
                      <th width="10%" class="text-center">Deuda</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{ account_receivable.broadcast_date }}</td>
                      <td class="text-center">{{ account_receivable.expiration_date }}</td>
                      <td class="text-center">{{ account_receivable.coin }}</td>
                      <td class="text-right">{{ account_receivable.total }}</td>
                      <td class="text-right">{{ account_receivable.balance }}</td>
                
                    </tr>
                  </tbody>
                </table>
              </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="3">
            <b-form-group label="">
              <b-button class="form-control" type="submit" variant="primary"><i class="fas fa-save"></i> Guardar</b-button>
            </b-form-group>
          </b-col>

          
        </b-row>
      </b-form>
  
     
     
      
    </b-modal>
  </div>
</template>
<style>



</style>
<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "ModalsProduct",
  data() {
    return {
        modalAmortizations:false,
        module:'Charge',
        role:2,
        id_account_receivable:0,
        amortizations: [],
        account_receivable:{
          type_invoice:'',
          serie:'',
          number:'',
          coin:'',
          total:'',
          fee:'',
          balance:'',
        },
        amortization: {
          id_charge:'',
          id_account_receivable:'',
          id_client:'',
          id_user:'',
          id_sale:0,
          id_establishment:0,
          broadcast_date:moment(new Date()).local().format("YYYY-MM-DD"),
          date_now:moment(new Date()).local().format("YYYY-MM-DD"),
          payment_method:'008',
          document:'',
          coin:'PEN',
          exchange_rate:'1.00',
          bank:'',
          cash:'1',
          number_op:'',
          observation:'',
          total: (0).toFixed(2),
          applied:(0).toFixed(2),
          balance:(0).toFixed(2),
          state:1,
      },
        payment_method: [
          {value :"001", text :'DEPÓSITO EN CUENTA'},
          {value :"003", text :'TRANSFERENCIA DE FONDOS'},
          {value :"004", text :'ORDEN DE PAGO'},
          {value :"005", text :'TARJETA DE DÉBITO'},
          {value :"006", text :'TARJETA DE CRÉDITO'},
          {value :"007", text :'CHEQUES CON LA CLÁUSULA DE "NO NEGOCIABLE"'},
          {value :"008", text :'EFECTIVO'},
          {value :"009", text :'EFECTIVO, EN LOS DEMÁS CASOS'},
          {value :"101", text :'TRANSFERENCIAS - COMERCIO EXTERIOR'},
          {value :"102", text :'CHEQUES BANCARIOS  - COMERCIO EXTERIOR'},
        ],

        coins:[
        {value: "PEN", text : "Soles"},
        {value: "USD", text : "Dolares"},
      ],

      bank:[
        {value :'', text:'Ninguno'},
        {value :'001', text:'BANCO CENTRAL DE RESERVA DEL PERU'},
        {value :'002', text:'BANCO DE CREDITO DEL PERU'},
        {value :'003', text:'BANCO INTERNACIONAL DEL PERU'},
        {value :'005', text:'BANCO LATINO'},
        {value :'007', text:'BANCO CITIBANK N.A.'},
        {value :'008', text:'BANCO STANDARD CHARTERED'},
        {value :'009', text:'BCO.SCOTIABANK PERU SAA (ANTES WIESE SUDAMERIS)'},
        {value :'011', text:'BANCO CONTINENTAL'},
        {value :'018', text:'BANCO DE LA NACION'},
        {value :'023', text:'BANCO COMERCIO'},
        {value :'026', text:'BANCO NORBANK'},
        {value :'037', text:'BANCO DEL PROGRESO'},
        {value :'038', text:'BANCO INTERAMERICANO DE FINANZAS'},
        {value :'041', text:'BANCO SUDAMERICANO'},
        {value :'043', text:'BANCO DEL TRABAJO'},
        {value :'044', text:'BANCO SOLVENTA'},
        {value :'045', text:'BANCO SERBANCO'},
        {value :'046', text:'BANK BOSTON N.A. SUCURSAL DEL PERU'},
        {value :'047', text:'ORION CORPORACION DE CREDITO'},
        {value :'048', text:'BANCO NUEVO PAIS'},
        {value :'049', text:'MIBANCO'},
        {value :'050', text:'BANQUE NATIONALE DE PARIS - ANDES S.A.'},
        {value :'053', text:'BANCO HSBC'},
        {value :'056', text:'BANCO SANTANDER PERU S.A.'},
        {value :'071', text:'CORPORACION FINANCIERA DE DESARROLLO - COFIDE'},
        {value :'083', text:'SOLUCION - FINANCIERA DE CREDITO DEL PERU'},
        {value :'086', text:'FINANDAEWOO S.A.'},
        {value :'087', text:'FINANCIERA C.M.R.'},
        {value :'088', text:'VOLVO FINANCE PERU'},
        {value :'089', text:'FINANCIERA CORDILLERA S.A.'},
        {value :'091', text:'GENERALI PERU CIA. SEGUROS'},
        {value :'092', text:'LA VITALICIA'},
        {value :'093', text:'REASEGURADORA PERUANA'},
        {value :'094', text:'SEGUROS LA FENIX PERUANA'},
        {value :'095', text:'SECREX  CIA. SEGUROS'},
        {value :'099', text:'OTROS'},
      ],
    
      errors: {
        id_client: false,
        payment_method: false,
        bank: false,
        number_op: false,
        broadcast_date: false,
        coin: false,
        exchange_rate:false,
        total: false,
      },

     
    };
  },
  created (){
    
  },
  mounted () {
    EventBus.$on('ModalAmortizationsV2Show', (id_account_receivable) => {
      this.modalAmortizations = true;
      this.id_account_receivable = id_account_receivable;
      this.ViewAccountReceivable();
    });
    
  },
  methods: {
      ViewAccountReceivable,
      Validate,
      AddAmortization,
      CodeInvoice,

      DataPrint,
      Print,
  },
  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    },
    id_establishment: function () {
      let establishment = window.localStorage.getItem("id_establishment");
      establishment = JSON.parse(je.decrypt(establishment));
      return establishment;
    }
  },
};

function CodeInvoice(code) {
  return CodeToName.CodeInvoice(code);
}
//lis
function ViewAccountReceivable() {
    let me = this;
    let url = me.url_base + "account-receivable/view/"+me.id_account_receivable;
    axios({
      method: "GET",
      url:url,
      headers: { token: me.token, module: me.module, role: me.role },
    })
    .then(function (response) {
      if (response.data.status == 200) {
        me.account_receivable.broadcast_date = response.data.result.broadcast_date;
        me.account_receivable.expiration_date = response.data.result.expiration_date;
        me.account_receivable.type_invoice = response.data.result.type_invoice;
        me.account_receivable.serie = response.data.result.serie;
        me.account_receivable.number = response.data.result.number;
        me.account_receivable.coin = response.data.result.coin;
        me.account_receivable.total = response.data.result.total;
        me.account_receivable.fee = response.data.result.fee;
        me.account_receivable.balance = response.data.result.balance;

        me.amortization.id_account_receivable = me.id_account_receivable;
        me.amortization.coin = response.data.result.coin;
        me.amortization.total = parseFloat(me.account_receivable.balance);
        me.amortization.total = parseFloat(me.amortization.amount).toFixed(2);

        
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function Validate() {

  this.errors.payment_method = this.amortization.payment_method.length == 0 ? true : false;
  if (this.amortization.payment_method != "008") {
    this.errors.number_op = this.amortization.number_op.length  == 0 ? true : false;
    this.errors.bank = this.amortization.bank.length == 0 ? true : false;
  }
  this.errors.broadcast_date = this.amortization.broadcast_date.length == 0 ? true : false;
  this.errors.coin = this.amortization.coin.length == 0 ? true : false;
  this.errors.exchange_rate = this.amortization.exchange_rate.length == 0 ? true : false;
  this.errors.total = parseFloat(this.amortization.total) <= 0 ? true : false;

  if (this.errors.payment_method == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.number_op == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.bank == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.broadcast_date == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.coin == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.exchange_rate == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.total == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }

  let me = this;

  Swal.fire({
    title: 'Esta seguro de registrar la amortización ?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, Estoy de Acuerdo!'
  }).then((result) => {
    if (result.isConfirmed) {
      this.AddAmortization();
    }
  })

}

function AddAmortization() {
  let me = this;
  me.amortization.id_user = me.user.id_user;
  me.amortization.id_establishment = me.id_establishment;
  let url = me.url_base + "settlement-collection/add-amortization";
  let data = me.amortization;
  me.isLoading = true;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json",token: me.token, module: me.module, role: 2,},
  })
    .then(function (response) {
      if (response.data.status == 201) {
          me.amortization.id_charge = '';
          me.amortization.id_client = '';
          me.amortization.id_user = '';
          me.amortization.broadcast_date = moment(new Date()).local().format("YYYY-MM-DD");
          me.amortization.payment_method = '008';
          me.amortization.document = '';
          me.amortization.coin = 'PEN';
          me.amortization.exchange_rate = '1.00';
          me.amortization.id_cash = '';
          me.amortization.bank = '';
          me.amortization.number_op = '';
          me.amortization.observation = '';
          me.amortization.total =  (0).toFixed(2);
          me.amortization.applied = (0).toFixed(2);
          me.amortization.balance = (0).toFixed(2);
          me.amortization.state = 1;
          me.client = null;

          me.DataPrint(response.data.result.id_charge);
          Swal.fire({ icon: 'success', text: 'Se ha registrado la amortización', timer: 3000,})
          EventBus.$emit('RefreshAccountReceivable');
          me.modalAmortizations = false;
      } else if(response.data.status == 400) {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }else{
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }

      me.isLoading = false;
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = false;
    });
}


function DataPrint(id_charge) {

let me = this;

  let url = me.url_base + "charge/data-print/"+id_charge;
  let data = me.sale;
  axios({
    method: "GET",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role, },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      me.Print(response.data.result);
    } 

  })

}

function Print(info) {
let url = 'http://localhost/print/consumirapi-charge.php';
var data = new FormData(); 
data.append("info",JSON.stringify(info)); 
axios({
  method: "POST",
  url: url,
  data:data,
  headers: {
    "Content-Type": "application/json",
    "Accept":"*/*",
  },
})
  .then(function (response) {
   
  })
  .catch((error) => {
    console.log(error);
  });
}
</script>
